import { __assign } from "tslib";
import React from 'react';
export function SecureCss(_a) {
    var css = _a.css, containerProps = _a.containerProps, type = _a.type;
    var cleanCss = css.replace(/</g, '&lt;');
    return (React.createElement("style", __assign({}, (type === undefined
        ? { type: 'text/css' }
        : type === null
            ? {}
            : { type: type }), containerProps, { dangerouslySetInnerHTML: { __html: cleanCss } })));
}
//# sourceMappingURL=SecureCss.js.map